import {
  uploadPOCTool,
  uploadSuperPOCTools,
} from '../../../../api/POCCMSPortalAPI/pointOfCareTools/POCToolsCalls';
import {convertingToFinalObject} from '../../../../Util/converter';
import {autoloadFiles, uploadImage} from '../../../../Util/loader';

export const createNewPOCTool = async ({
  pocToolSummary,
  displayPocToolContent,
  setIsLoading,
  setIsSubmitted,
  navigate,
  isPublished = false,
}) => {
  setIsLoading(true);
  let isThereError = false;
  let PreviewImageUrl = await uploadImage(pocToolSummary.image, navigate);
  const promises = await autoloadFiles(
    isThereError,
    displayPocToolContent,
    navigate,
  );

  const POCToolReadyToSend = await Promise.all(promises);

  if (!isThereError) {
    if (POCToolReadyToSend[0]?.type === 'minitool') {
      return uploadSuperPOCTools({
        name: pocToolSummary.name,
        description: pocToolSummary.description,
        PreviewImageUrl: PreviewImageUrl,
        minitool: convertingToFinalObject(POCToolReadyToSend),
        isPublished: isPublished,
      })
        .then(createdPOCToolsId => {
          setIsLoading(false);
          setIsSubmitted(true);
          return createdPOCToolsId;
        })
        .catch(err => {
          if (err === 401) {
            navigate('/Login');
            throw err;
          }
          alert(err);
        });
    } else {
      return uploadPOCTool({
        name: pocToolSummary.name,
        description: pocToolSummary.description,
        PreviewImageUrl: PreviewImageUrl,
        categories: convertingToFinalObject(POCToolReadyToSend),
        isPublished: isPublished,
      })
        .then(createdPOCToolsId => {
          setIsLoading(false);
          setIsSubmitted(true);
          return createdPOCToolsId;
        })
        .catch(err => {
          if (err === 401) {
            navigate('/Login');
            throw err;
          }
          alert(err);
        });
    }
  }
};
